module.exports = __webpack_public_path__ + "static/media/nav_06.2909d561.svg";